import {
  IonHeader, IonPage, IonToolbar, IonTitle, IonContent, IonFab, IonFabButton,IonIcon, IonItem, IonRow, IonCardContent, IonCard, IonCol, IonLabel, IonRadioGroup,IonRadio, IonCardHeader, IonSelect, IonButton, IonSelectOption,IonBadge, IonRange, IonInput
} from '@ionic/react';
import React from 'react';
import * as API from "../utils/api";
import * as apiConstants from "../constants/api-endpoint";
import { CustomerDetail } from '../interface/customerDetails.i';
import { camera, chevronBackSharp } from 'ionicons/icons';
import Swal from 'sweetalert2';
import LogoutPage from './Logout';
import styled from "styled-components";
import { CAMERA } from '../utils/shared';
import { Header, Question, SiteSurveyQuestionResponse } from '../interface/question.i';

class SiteSurveyPage extends React.Component<any, any> {

  private selectedData: CustomerDetail;
  private pageNumber: number = 1;
  private pageNum: number = 2;
  private page: number = 3;
  private previousPageNumber: number = 0;
  private currentPageNumber: number = 0;
  private nextPageNumber: number = 0;
  
constructor(props: any) {
  super(props);
  console.log(" props data ==> ", props);
  this.selectedData = props.location.state.userData; 
  this.state = { data: [] as Question[], selectedData: this.selectedData, headerTO:  {} as Header,  siteSurveyQuestion : {} as SiteSurveyQuestionResponse}
}

componentDidMount(){
    this.SiteSurvey(this.selectedData.id,this.pageNumber);
}

goBack = ()=>{
  //To goto previous page
  if (this.previousPageNumber != 0) {
    this.nextPage(this.selectedData.id,this.previousPageNumber,this.state.headerTO.compartmentType)
  } else if(this.currentPageNumber == 3 && this.previousPageNumber == 0) {
    this.SiteSurvey(this.selectedData.id,this.pageNum)
  } else {
    this.props.history.goBack();
  }
}

gotoNextPage = ()=>{
  //To goto nextpage
  this.nextPage(this.selectedData.id,this.nextPageNumber,this.state.headerTO.compartmentType)
  this.updateSiteSurveyValues();
}

CompleteSurvey = (id:number) => {
  //to display popup alertbox on clicking submit button
  Swal.fire({
    title: 'Are you sure you want to submit?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: 'Submit',
    denyButtonText: `Don't Submit`,
  }).then((result) => {
    if (result.isConfirmed) {
      const name = localStorage.username;
      const submit = apiConstants.submitSurvey + id + '/' + name;
      API.authGetRequest(submit, '')
      .then((res) => {
        const responseData = res.data;
      Swal.fire('Success!', responseData.message ,'success')
      this.props.history.push('/upcoming-schedule?selection=serviceprogramtechnicalonboardingschedule')
      })
    } else {
      Swal.fire('Changes are not saved', '', 'info')
    }
  })
.catch((error) => {
  console.log("err===", error);
})
}

nextPage =(id : number, pageno : number, compartment : string) => {
  //To goto next page
  const compartmentType = this.state.headerTO.compartmentType;
  const url = apiConstants.sitesurveyquestions + id  + "&pageNumber=" + pageno + "&compartmentType=" + compartmentType;
    API.authGetRequest(url, '')
      .then((res) => {
        if(res && res.data){
        const responseData = res.data;
        this.currentPageNumber = responseData.currentPageNumber;
        this.previousPageNumber = responseData.previousPageNumber;
        this.nextPageNumber = responseData.nextPageNumber;
        const data =responseData.siteSurveyQuestionTOs as Question[];
        if (data && data.length) {
          data.map((obj:Question) => {
            if (obj.answerType === 'drop down' || obj.answerType == 'drop down hide') {
              const str = obj.answerValue as string;
              obj.answerValue = str.split(',');
            }
            if (obj.answerType === 'Choose equipment') {
              const str = obj.answerValue as string;
              const label = obj.label as string;
              obj.answerValue = str.split(',');
            }
            if (obj.answerType === 'range' || obj.answerType == 'range hide') {
              const str = obj.answerValue as string;
              const label = obj.label as string;
              obj.answer = obj.answer ? obj.answer : '0';
              obj.answerValue = str.split('-').map(Number);
              if (label) {
                obj.label = label.split('-');
              }
            } 
          })
        }
        this.setState({
          headerTO: responseData.headerTO,
          data: responseData.siteSurveyQuestionTOs,
          siteSurveyQuestion: responseData
        })
      }
    })
    }

SiteSurvey =(id : number, pageno : number) => {
  //To display property info questions
  const val = "Property Info";
  const url = apiConstants.sitesurveyquestions + id  + "&pageNumber=" + pageno + "&compartmentType=" + val;
    API.authGetRequest(url, '')
      .then((res) => {
        if(res && res.data){
        const responseData = res.data;
        this.currentPageNumber = responseData.currentPageNumber;
        this.previousPageNumber = responseData.previousPageNumber;
        this.nextPageNumber = responseData.nextPageNumber;
        const data =responseData.siteSurveyQuestionTOs as Question[];
        if (data && data.length) {
          data.map((obj:Question) => {
            if (obj.answerType === 'drop down' || obj.answerType == 'drop down hide') {
              const str = obj.answerValue as string;
              obj.answerValue = str.split(',');
            }
            if (obj.answerType === 'checkbox') {
              const str = obj.answerValue as string;
            }
            if (obj.answerType === 'Choose equipment') {
              const str = obj.answerValue as string;
              const label = obj.label as string;
              obj.answerValue = str.split(',');
            }
            if (obj.answerType === 'range') {
              const str = obj.answerValue as string;
              const label = obj.label as string;
              obj.answer = obj.answer ? obj.answer : '0';
              obj.answerValue = str.split('-').map(Number);
              if (label) {
                obj.label = label.split('-');
              }
            } 
          })
        }
        console.log("siteSurvey==", res);
        this.setState({
          headerTO: responseData.headerTO,
          data: responseData.siteSurveyQuestionTOs,
          siteSurveyQuestion: responseData
        })
      }
    })
}

OnChangeDropdown =(event : any,id : number,index : number,pageno : number) => {
  //To display questions based on dropdown value choosen
  const val = event.detail.value;
  console.log("dropdown value",val);
  const url = apiConstants.sitesurveyquestions + id + '&pageNumber='  + this.page + '&compartmentType=' + val;
    API.authGetRequest(url, '')
      .then((res) => {
        if(res && res.data){
        const responseData = res.data;
        this.currentPageNumber = responseData.currentPageNumber;
        this.previousPageNumber = responseData.previousPageNumber;
        this.nextPageNumber = responseData.nextPageNumber;
        const data =responseData.siteSurveyQuestionTOs as Question[];
        if (data && data.length) {
          data.map((o) => {
            if (o.answerType === 'drop down') {
              const str = o.answerValue as string;
              o.answerValue = str.split(',');
            }
            if (o.answerType === 'Choose equipment') {
              const str = o.answerValue as string;
              const label = o.label as string;
              o.answerValue = str.split(',');
            }
            if (o.answerType === 'range') {
              const str = o.answerValue as string;
              const label = o.label as string;
              o.answer = o.answer ? o.answer : '0';
              o.answerValue = str.split('-').map(Number);
              if (label) {
                o.label = label.split('-');
              }
            } 
          })
        }
        this.setState({
          headerTO: responseData.headerTO,
          data: responseData.siteSurveyQuestionTOs,
          siteSurveyQuestion: responseData
        })
      }
    })
      this.ServiceQuestionUpdate(event.detail.value,index);
      this.updateSiteSurveyValues();
}

OnChangeRadio =(event : any,id : number,index : number,pageno : number) => {
  //To display questions based on radiobutton values choosen
  const val = event.detail.value;
  console.log("radio value",val);
  const nextPage = this.nextPageNumber + 1;
  const goNextPage = this.nextPageNumber + 2;
  if(val == 'Yes'){
  this.nextPage(this.selectedData.id,this.nextPageNumber,this.state.headerTO.compartmentType)
  } else if (val == 'No' && this.state.data[index].mobileView != 'IS THERE DRAINAGE FIELD AVAILABLE') {
    this.nextPage(this.selectedData.id,nextPage,this.state.headerTO.compartmentType)
  } else if (val == 'No' && this.state.data[index].mobileView == 'IS THERE DRAINAGE FIELD AVAILABLE') {
    this.nextPage(this.selectedData.id,this.nextPageNumber + 3,this.state.headerTO.compartmentType)
  } else if(val == 'Diverter Valve'){
    this.nextPage(this.selectedData.id,this.nextPageNumber,this.state.headerTO.compartmentType)
  } else if(val == 'D-Box'){
    this.nextPage(this.selectedData.id,nextPage,this.state.headerTO.compartmentType)
  } else if(val == 1){
    this.nextPage(this.selectedData.id,goNextPage,this.state.headerTO.compartmentType)
  } else if(val == 2){
    this.nextPage(this.selectedData.id,this.nextPageNumber,this.state.headerTO.compartmentType)
  }
  this.ServiceQuestionUpdate(event.detail.value,index);
  this.updateSiteSurveyValues();
}

getEquipmentType=()=>{
    this.SiteSurvey(this.selectedData.id,this.nextPageNumber);
    this.updateSiteSurveyValues();
}

updateSiteSurveyValues=() => {
  //Update sitesurvey values to the database
      const siteSurveyQuestionTOs = this.state.data as Question[];
      siteSurveyQuestionTOs.map((el:Question) => {
      if(el.answerType === 'drop down' || el.answerType == 'drop down hide')
      {
        el.answerValue = el.answerValue.toString();
      }
      if(el.answerType === 'Choose equipment' || el.answerType == 'choose addon')
      {
        el.answerValue = el.answerValue.toString();
      }
      if(el.answerType === 'range')
      {
        el.answerValue = (el.answerValue as string[]).join('-');
        el.label = (el.label as string[]).join('-');
        el.answer = el.answer.toString();
      }
      if(el.answerType === 'multiselect' && el.answer === 'null')
      {
        el.answer = el.answer.toString();
      }
      if(el.answerType === 'checkbox' && el.answer === 'null')
      {
        el.answer = el.answer.toString();
      }
    });
    
    let update = this.state.siteSurveyQuestion;
    let num = this.selectedData.id;
    let name = localStorage.username;
    const updateSurveyData = API.authPostRequest(apiConstants.updateSurvey + num + '/' + name, update);
    console.log("url",updateSurveyData);
    updateSurveyData
      .then(async (res) => {
        console.log('Survey Data Updated Successfully',res);
      })
      .catch((error) => {
        console.log("err===", error);
      });
}

textOnchange(event: any,index: number) {
  this.ServiceQuestionUpdate(event,index);
}

radioOnchange = (event: any, index : number) => {
  //Logics to hide & disable questions based on radiobutton question and answer choosen
  if (!event?.detail?.value) return;
  const updateEvent = this.state.data as Question[];
  const selectedQuestion = event?.target?.innerText;
  const selectedAnswer = event?.detail?.value;
  if (selectedQuestion.indexOf('CONDITION OF LID') > -1 || selectedQuestion.indexOf('IS THERE AN EFFLUENT FILTER IN THE OUTLET BAFFLE') > -1){
     updateEvent.map((el: Question) => {
        if(el.questionReference == 'lid_condition' || el.questionReference == 'eff_filter_present' || el.questionReference == 'lid_condition_single' || el.questionReference == 'lid_condition_scnd') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Sat" || selectedAnswer == "No") {
          switch (el.questionReference) {
            case 'lid_condition_unsat':
            case 'lid_condition_unsat_single':
            case 'septic_tank_filter_size':
            case 'poly_filter_size':
            case 'septic_tank_filter_type':
            case 'lid_at_grade':
            case 'lid_condition_unsat_scnd':
              el.disableFlag = true;
              el.hideElement = false;
              break;
            case 'service_prgm_candidate':
              el.disableFlag = false;
          }
      } else  if (selectedAnswer == "Unsat" || selectedAnswer == "Yes") {
        switch (el.questionReference) {
          case 'lid_condition_unsat':
          case 'lid_condition_unsat_single':
          case 'septic_tank_filter_size':
          case 'poly_filter_size':
          case 'septic_tank_filter_type':
          case 'lid_at_grade':
          case 'lid_condition_unsat_scnd':
            el.disableFlag = false;
            el.hideElement = true;
            break;
          case 'service_prgm_candidate':
          case 'no_why':
          case 'out_baf_opening':
          case 'type_of_filter':
          case 'filter_size':
          case 'poly_fil_size':
          case 'baf_extension_accessible':
          case 'replacement_baf_size':
          case 'no_why':
            el.disableFlag = true;
            break;

      }
    }
    });
    this.setState({
      data: updateEvent
    });
  }
  if (selectedQuestion.indexOf('CONDITION OF RISER') > -1 || selectedQuestion.indexOf('IF NO FILTER PRESENT, IS THIS A CANDIDATE FOR SERVICE PROGRAM') > -1){
    updateEvent.map((el: Question) => {
       if(el.questionReference == 'riser_condition' || el.questionReference == 'service_prgm_candidate' || el.questionReference == 'riser_condition_single') {
         el.answer = selectedAnswer;
       }
       if (selectedAnswer == "Sat" || selectedAnswer == "No") {
         switch (el.questionReference) {
           case 'riser_cond_unsat':
           case 'riser_cond_unsat_single':
           case 'riser_cond_unsat_scnd':
           case 'out_baf_opening':
           case 'type_of_filter':
           case 'filter_size':
           case 'baf_extension_accessible':
           case 'replacement_baf_size':
           case 'riser_lid_needed_access':
           case 'lid_diameter_single':
           case 'lid_diameter_single_add':
           case 'lid_diameter_single_add1':
           case 'filter_riser_height_single_add1':
           case 'filter_riser_height_single':
           case 'filter_riser_height_single_add':
           case 'lid_diameter_double':
           case 'filter_riser_height_double':
             el.disableFlag = true;
             el.hideElement = false;
             break;
           case 'service_prgm_candidate':
           case 'no_why':
             el.disableFlag = false;
         }
     } else  if (selectedAnswer == "Unsat" || selectedAnswer == "Yes") {
       switch (el.questionReference) {
         case 'riser_cond_unsat':
         case 'riser_cond_unsat_single':
         case 'riser_cond_unsat_scnd':
         case 'out_baf_opening':
         case 'type_of_filter':
         case 'filter_size':
         case 'baf_extension_accessible':
         case 'replacement_baf_size':
         case 'riser_lid_needed_access':
         case 'lid_diameter_single':
         case 'lid_diameter_single_add':
         case 'lid_diameter_single_add1':
         case 'filter_riser_height_single':
         case 'filter_riser_height_single_add':
         case 'filter_riser_height_single_add1':
         case 'lid_diameter_double':
         case 'filter_riser_height_double':
           el.disableFlag = false;
           el.hideElement = true;
           break;
         case 'no_why':
           el.disableFlag = true;
           break;

     }
   }
   });
   this.setState({
     data: updateEvent
   });
 }
 if (selectedQuestion.indexOf('IS THERE A RISER') > -1 || selectedQuestion.indexOf('IS THE OUTLET BAFFLE DIRECTLY BELOW ACCESS OPENING') > -1
     || selectedQuestion.indexOf('CORNER PORTS AT GRADE') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'riser' || el.questionReference == 'out_baf_opening' || el.questionReference == 'riser_single' || el.questionReference == 'riser_scnd' || el.questionReference == 'corner_ports_drain_field_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "Yes" || selectedAnswer == "yes") {
       switch (el.questionReference) {
         case 'riser_height':
         case 'riser_depth':
         case 'riser_type_hei':
         case 'riser_type_hei_fst_double':
         case 'riser_condition':
         case 'riser_cond_unsat':
         case 'lid_riser_location_single':
         case 'lid_riser_location_fst_double':
         case 'riser_height_single':
         case 'riser_height_scnd':
         case 'riser_depth_scnd':
         case 'riser_type_hei_scnd_double':
         case 'riser_condition_scnd':
         case 'riser_cond_unsat_scnd':
         case 'lid_riser_location_scnd_double':
         case 'type_of_filter':
         case 'filter_size':
         case 'no_of_corner_ports_scnd':
         case 'water_ins_port_scnd':
           el.disableFlag = false;
           break;
       }
   } else  if (selectedAnswer == "No" || selectedAnswer == "no") {
     switch (el.questionReference) {
        case 'riser_height':
        case 'riser_depth':
        case 'riser_depth_single':
        case 'riser_type_hei':
        case 'riser_type_hei_fst_double':
        case 'riser_condition':
        case 'riser_cond_unsat':
        case 'lid_riser_location_single':
        case 'lid_riser_location_fst_double':
        case 'riser_height_single':
        case 'riser_height_scnd':
        case 'riser_depth_scnd':
        case 'riser_type_hei_scnd_double':
        case 'riser_condition_scnd':
        case 'riser_cond_unsat_scnd':
        case 'lid_riser_location_scnd_double':
        case 'type_of_filter':
        case 'filter_size':
        case 'no_of_corner_ports_scnd':
        case 'water_ins_port_scnd':
         el.disableFlag = true;
         break;

   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('IN ORDER TO SERVICE THE FILTER,ARE RISER AND LID NEEDED FOR ACCESS') > -1 
|| selectedQuestion.indexOf('IS LID AT GRADE')> -1 || selectedQuestion.indexOf('MEASURABLE WATER INSIDE PORTS') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'riser_lid_needed_access' || el.questionReference == 'lid_grade_pump' || el.questionReference == 'water_ins_port') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "Yes") {
       switch (el.questionReference) {
         case 'lid_diameter_single':
         case 'filter_riser_height_single':
         case 'lid_diameter_single_add':
         case 'filter_riser_height_single_add':
         case 'lid_diameter_single_add1':
         case 'filter_riser_height_single_add1':
         case 'lid_diameter_double':
         case 'filter_riser_height_double':
         case 'fol_up_needed':
          el.disableFlag = false;
          el.hideElement = true;
           break;
        case 'depth_of_lid_pump':
        case 'depth_of_lid_vault':
          el.disableFlag = true;
           break;
       }
   } else  if (selectedAnswer == "No") {
     switch (el.questionReference) {
       case 'lid_diameter_single':
       case 'filter_riser_height_single':
       case 'lid_diameter_single_add':
       case 'filter_riser_height_single_add':
       case 'lid_diameter_single_add1':
       case 'filter_riser_height_single_add1':
       case 'lid_diameter_double':
       case 'filter_riser_height_double':
       case 'fol_up_needed':
         el.disableFlag = true;
         el.hideElement = false;
         break;
       case 'depth_of_lid_pump':
       case 'depth_of_lid_vault':
         el.disableFlag = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('CONDITION OF LID') > -1 || selectedQuestion.indexOf('CONDITION OF ACCESS LID')>-1 || 
   selectedQuestion .indexOf('DEEP PORTS AT GRADE') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'lid_cond_pump' || el.questionReference == 'lid_condition_peat_moss' || el.questionReference == 'port_at_grade_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "Sat" || selectedAnswer == "yes") {
       switch (el.questionReference) {
        case 'lid_cond_unsat_pump':
        case 'lid_cond_unsat_vault':
        case 'lid_unsat_reason_peat_moss':
          el.disableFlag = true;
          el.hideElement = false;
          break;
        case 'water_ins_deep_port_scnd':
          el.disableFlag = false;
           break;
       }
   } else  if (selectedAnswer == "Unsat" || selectedAnswer == 'no') {
     switch (el.questionReference) {
        case 'lid_cond_unsat_pump':
        case 'lid_cond_unsat_vault':
        case 'lid_unsat_reason_peat_moss':
         el.disableFlag = false;
         el.hideElement = true;
         break;
        case 'water_ins_deep_port_scnd':
         el.disableFlag = true;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('ELECTRICAL CONNECTIONS ARE') > -1 || selectedQuestion.indexOf('CORNER PORTS,AT GRADE') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'elec_conn_pump' || el.questionReference == 'elec_conn_vault' || el.questionReference == 'corner_ports_drain_field') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "EXTERIOR" || selectedAnswer == 'Yes') {
       switch (el.questionReference) {
        case 'interior_pump':
        case 'interior_vault':
           el.disableFlag = true;
           break;
        case 'exterior_pump':
        case 'exterior_vault':
        case 'no_of_corner_ports':
        case 'water_ins_port':
        case 'port_at_grade':
        case 'water_ins_deep_port':
          el.disableFlag = false;
          break;
       }
   } else  if (selectedAnswer == "INTERIOR" || selectedAnswer == 'No') {
     switch (el.questionReference) {
        case 'exterior_pump':
        case 'exterior_vault':
        case 'no_of_corner_ports':
        case 'water_ins_port':
        case 'port_at_grade':
        case 'water_ins_deep_port':
         el.disableFlag = true;
         break;
         case 'interior_pump':
         case 'interior_vault':
         el.disableFlag = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('LOCATION OF LID') > -1 || selectedQuestion.indexOf('LOCATION OF FIRST LID') > -1 || selectedQuestion.indexOf('LOCATION OF SECOND LID') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'lid_location_single' || el.questionReference == 'lid_location_single_add' || el.questionReference == 'lid_location_single_add1'
        || el.questionReference == 'lid_location_fst_double' || el.questionReference == 'lid_location_scnd_double' || el.questionReference == 'lid_location_atu' || el.questionReference == 'second_lid_location_atu') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "Buried") {
       switch (el.questionReference) {
        case 'riser':
        case 'riser_height':
        case 'riser_type_hei':
        case 'riser_type_hei_fst_double':
        case 'riser_condition':
        case 'riser_single':
        case 'riser_height_single':
        case 'riser_type_hei_single':
        case 'riser_condition_single':
        case 'riser_type_hei_add':
        case 'riser_scnd':
        case 'riser_height_scnd':
        case 'riser_type_hei_scnd_double':
        case 'riser_condition_scnd':
        case 'second_riser_type_atu':
           el.disableFlag = true;
           break;
        case 'exterior_pump':
        case 'exterior_vault':
        case 'no_of_corner_ports':
          el.disableFlag = false;
          break;
       }
   } else  if (selectedAnswer == "At Grade") {
     switch (el.questionReference) {
        case 'exterior_pump':
        case 'exterior_vault':
        case 'no_of_corner_ports':
         el.disableFlag = true;
         break;
         case 'interior_pump':
         case 'interior_vault':
         case 'riser':
         case 'riser_height':
         case 'riser_type_hei':
         case 'riser_type_hei_fst_double':
         case 'riser_condition':
         case 'riser_single':
         case 'riser_height_single':
         case 'riser_type_hei_single':
         case 'riser_condition_single':
         case 'riser_type_hei_add':
         case 'riser_scnd':
         case 'riser_height_scnd':
         case 'riser_type_hei_scnd_double':
         case 'riser_condition_scnd':
         case 'second_riser_type_atu':
         el.disableFlag = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('CONDITION OF TREATMENT TANK') > -1){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'tank_condition_atu') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'Sat') {
       switch (el.questionReference) {
        case 'tank_cond_unsat_atu':
           el.disableFlag = true;
           el.hideElement = false;
           break;
       }
   } else  if (selectedAnswer == 'Unsat') {
     switch (el.questionReference) {
        case 'tank_cond_unsat_atu':
         el.disableFlag = false;
         el.hideElement = true;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('DEEP PORT AT GRADE') > -1 ){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'port_at_grade') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'Yes') {
       switch (el.questionReference) {
        case 'water_ins_deep_port':
           el.disableFlag = false;
           break;
       }
   } else  if (selectedAnswer == 'No') {
     switch (el.questionReference) {
        case 'water_ins_deep_port':
         el.disableFlag = true;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
if (selectedQuestion.indexOf('MEASURABLE WATER INSIDE PORT') > -1 ){
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'water_ins_port_scnd') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == 'yes') {
       switch (el.questionReference) {
        case 'fol_up_needed_scnd':
           el.disableFlag = false;
           el.hideElement = true;
           break;
       }
   } else if (selectedAnswer == 'no') {
     switch (el.questionReference) {
        case 'fol_up_needed_scnd':
         el.disableFlag = true;
         el.hideElement = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
}
  this.ServiceQuestionUpdate(event.detail.value,index);
}

dropdownOnchange = (event: any, index : number) => {
  //Logics to hide & disable questions based on dropdown question and answer choosen
  if (!event?.detail?.value) return;
  const updateEvent = this.state.data as Question[];
  const selectedQuestion = event?.target?.ariaLabel;
  const selectedAnswer = event?.detail?.value;
  if (selectedQuestion.indexOf('SEPTIC TANK SIZE (gals.)') > -1 || selectedQuestion.indexOf('IF FILTER CAN BE INSTALLED INTO BAFFLE, WHAT TYPE IS RECOMMENDED') >-1){    
     updateEvent.map((el: Question) => {
        if(el.questionReference == 'septic_tank_size' || el.questionReference == 'type_of_filter') {
          el.answer = selectedAnswer;
        }
        if (selectedAnswer == "Other" || selectedAnswer == 'Poly') {
          switch (el.questionReference) {
            case 'septic_tank_size_other':
            case 'septic_tank_size_other_add':
            case 'poly_fil_size':
              el.disableFlag = false;
              el.hideElement = true;
              break;
            case 'filter_size':
              el.disableFlag = true;
              el.hideElement = false;
              break;
          }
      } else if(selectedAnswer == 'Bristle') {
        switch (el.questionReference) {
          case 'septic_tank_size_other':
          case 'septic_tank_size_other_add':
          case 'poly_fil_size':
            el.disableFlag = true;
            el.hideElement = false;
            break;
          case 'filter_size':
            el.disableFlag = false;
            el.hideElement = true;
            break;

      }
    }
    });
    this.setState({
      data: updateEvent
    });
  } 

  if (selectedQuestion.indexOf('SIZE OF LID') > -1){    
    updateEvent.map((el: Question) => {
       if(el.questionReference == 'size_lid' || el.questionReference == 'size_lid_scnd_double'
       || el.questionReference == 'size_lid_pump' || el.questionReference == 'size_lid_vault') {
         el.answer = selectedAnswer;
       }
       if (selectedAnswer == "Other") {
         switch (el.questionReference) {
           case 'lid_size':
           case 'lid_size1':
           case 'type_size_lid_pump':
           case 'type_size_lid_vault':
             el.disableFlag = false;
             el.hideElement = true;
             break;
         }
     } else {
       switch (el.questionReference) {
         case 'lid_size':
         case 'lid_size1':
         case 'type_size_lid_pump':
         case 'type_size_lid_vault':
           el.disableFlag = true;
           el.hideElement = false;
           break;
     }
   }
   });
   this.setState({
     data: updateEvent
   });
 } 
 if (selectedQuestion.indexOf('TYPE OF FILTER') > -1){    
  updateEvent.map((el: Question) => {
     if(el.questionReference == 'septic_tank_filter_type') {
       el.answer = selectedAnswer;
     }
     if (selectedAnswer == "Poly") {
       switch (el.questionReference) {
         case 'poly_filter_size':
           el.disableFlag = false;
           el.hideElement = true;
           break;
        case 'septic_tank_filter_size':
           el.disableFlag = true;
           el.hideElement = false;
           break;
       }
   } else if(selectedAnswer == 'Bristle') {
     switch (el.questionReference) {
       case 'septic_tank_filter_size':
         el.disableFlag = false;
         el.hideElement = true;
         break;
       case 'poly_filter_size':
         el.disableFlag = true;
         el.hideElement = false;
         break;
   }
 }
 });
 this.setState({
   data: updateEvent
 });
} 
  this.ServiceQuestionUpdate(event.detail.value,index);
}

dropdownMultiOnchange = (event: any, index : number) => {
  //To save selected checkbox event values
  const val = event.detail.value;
  const finalvalue = val.toString();
  console.log("finalvalue=",finalvalue)
  this.ServiceQuestionUpdate(finalvalue,index);
}

ServiceQuestionUpdate(event:any,index:number){
  //To save selected radio and dropdown event values
  const updatedData = {...this.state.siteSurveyQuestion};
  if(updatedData && updatedData.siteSurveyQuestionTOs.length > index  &&  updatedData.siteSurveyQuestionTOs[index]) {
    updatedData.siteSurveyQuestionTOs[index].answer = event;
    this.setState({
      siteSurveyQuestion: updatedData
    });
    console.log(event);
  }
}

rangeUpdate(event : any, index: number) {
  //To update range values
  const updatedData = {...this.state};
  if(updatedData && updatedData.data && updatedData.data.length && 
    updatedData.data.length > index && updatedData.data[index].answer) {
    updatedData.data[index].answer = event;

  this.setState({
    data : updatedData.data
  })
    console.log(event);
  }

  this.ServiceQuestionUpdate(event,index);
}

ionViewWillEnter() {
  console.log('ionViewWillEnter event fired')
}

ionViewWillLeave() {
  console.log('ionViewWillLeave event fired')
}

ionViewDidEnter() {
  console.log('ionViewDidEnter event fired')
}

ionViewDidLeave() {
  console.log('ionViewDidLeave event fired')
}

async takePhoto(index:number) {
 
  const formdata = CAMERA();
  this.uploadImage(await formdata,this.selectedData.id,index);
}

// Upload Captured Image
 uploadImage(formData:FormData, id : number,index : number) {
  const customerId = this.props.location.state.userData.propertyId;
  const townshipId = this.props.location.state.userData.townshipId;
  const compartmentType = this.state.data[index].compartmentType;
  const questionReference = this.state.data[index].questionReference;
  const type = "sitesurvey";
  const uploadRequest = API.authPostRequest(apiConstants.photoUploadUrl + id  + '&customerId=' +customerId + '&townshipId=' + townshipId + '&type=' + type  + '&compartment=' + compartmentType + '&questionReference=' + questionReference,formData);
  uploadRequest
    .then(async () => {
      console.log('ImageUploaded Successfully');
    })
    .catch((error) => {
      console.log(error);
    });
  };

// Convert base64 to blob
base64ToImage(dataURI: String) {
  const fileDate = dataURI.split(',');
  const byteString = atob(fileDate[1]);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const int8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i++) {
    int8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: 'image/png' });
  return blob;
}

render() {
  return (
      <InsPage>
      <IonPage> 
        <IonHeader>
          <IonToolbar>
            <IonRow>
            <IonCol size="4" >
            <IonItem lines="none" onClick={this.goBack} >
            <IonIcon color = "primary" slot="start" icon={chevronBackSharp} style={{fontSize : "40px", paddingTop: "10px"}} />
            </IonItem>
          </IonCol>
              <IonCol className="ion-align-self-center" style={{ textAlign: "justify" }}>
                <img src="assets/logo001.png" width="40%" />
              </IonCol>

            <LogoutPage/> 

            </IonRow>
          </IonToolbar>
          <IonToolbar color="secondary">

            <IonTitle>Powered By:<span><b>Septic Smart</b></span></IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
        
          <IonCard style={{ borderTop: "4px solid #53A658" }}>
            <IonCardHeader style={{ textAlign: "center" }}>
            <IonTitle className="iontitle"><b>{this.state?.headerTO?.title}</b></IonTitle>
            </IonCardHeader>

          {(this.state.data.map((user: any, index: number) => (
             <IonCardContent key={index} className="card_content"> 

              {(user.answerType === 'text' && user.hideElement) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap">{user.mobileView} </IonLabel>
                      <IonInput className="ion-text-wrap" style={{color : "#019849", fontWeight : "bold"}} value={user.answer} disabled={user.disableFlag} onIonChange={e => { this.textOnchange(e.detail.value, index) }}></IonInput>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

              {(user.answerType === 'Main Heading') ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="iontitle"><b>{user.mobileView}</b></IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

            {((user.answerType === 'photo') || (user.answerType === 'take photo' && user.hideElement)) ?
            <IonRow>
              <IonCol>
                <IonItem disabled={user.disableFlag}>
                  <IonLabel className= "ion-text-wrap">{user.mobileView}</IonLabel>
                  <IonFab horizontal="end">
                  <IonFabButton disabled={user.disableFlag}>
                  <IonIcon style = {{fontSize: "w3-tiny"}}icon={camera} onClick={() => this.takePhoto(index)}/>
                  </IonFabButton>
                  </IonFab>
                </IonItem>
              </IonCol>
            </IonRow>
            : null} 

              {(user.answerType === 'radio') ?
                <IonRow>
                  <IonCol>
                    <IonItem disabled={user.disableFlag}>
                        <IonRadioGroup className = "app-font" value={user.answer} style={{ display: "flex"}} onIonChange={e => { this.radioOnchange(e, index) }}>
                          <IonLabel className = "app-font">{user.mobileView}</IonLabel>
                          {user.answerValue.split(',').map((el: string, k: number) => (
                            <IonItem key={k} className="ion-item-top-adjust">
                              <IonLabel className='text-color'>{el}</IonLabel>
                              <IonRadio slot="start" style = {{color : 'green'}} value={el} disabled={user.disableFlag} />
                            </IonItem>))}
                        </IonRadioGroup>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

              {(user.answerType === 'Note' && user.hideElement) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap">{user.mobileView}</IonLabel>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

              {(user.answerType === 'choose addon') ?
                <IonRow>
                  <IonCol>
                    <IonItem disabled={user.disableFlag}>
                      <IonRadioGroup className="app-font" value={user.answer} style={{ display: "flex", width: '500px !important' }}
                      onIonChange={e => { this.OnChangeRadio(e, this.selectedData.id, index, this.currentPageNumber) }}>
                        <IonLabel className="app-font">{user.mobileView}</IonLabel>
                        {user.answerValue.split(',').map((el: string, k: number) => (
                          <IonItem key={k} className="ion-item-top-adjust">
                            <IonLabel className='text-color'>{el}</IonLabel>
                            <IonRadio slot="start" value={el} disabled={user.disableFlag} />
                          </IonItem>))}
                      </IonRadioGroup>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}
        

             {((user.answerType === 'drop down hide' && user.hideElement) || (user.answerType == 'drop down')) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap">{user.mobileView}</IonLabel>
                      <IonSelect style={{ width: '500px !important', color : "#019849", fontWeight : "bold"}} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.dropdownOnchange(e, index) }} >
                        {user.answerValue.map((el: string, k: number) => (
                          <IonSelectOption  value={el}>{el}</IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                    </IonCol>
                </IonRow>
                : null}

              {(user.answerType === 'Choose equipment') ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="ion-text-wrap">{user.mobileView}</IonLabel>
                      <IonSelect style={{ width: '500px !important', color : "#019849", fontWeight : "bold"}} disabled={user.disableFlag} value={user.answer} onIonChange={e => { this.OnChangeDropdown(e, this.selectedData.id, index, this.currentPageNumber) }}>
                        {user.answerValue.map((el: string, k: number) => (
                          <IonSelectOption value={el}>{el}</IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

              {((user.answerType === 'multiselect' && user.hideElement) || (user.answerType == 'checkbox')) ?
                <IonRow>
                  <IonCol>
                    <IonItem>
                      <IonLabel className="app-font">{user.mobileView} &nbsp; <IonBadge>{user.answer}</IonBadge></IonLabel>
                      <IonSelect multiple={true} style={{ width: '500px !important',color : "#019849", fontWeight : "bold"}} disabled={user.disableFlag} onIonChange={e => { this.dropdownMultiOnchange(e, index) }}>
                        {user.answerValue.split(',').map((el: string, k: number) => (
                          <IonSelectOption value={el}>{el}</IonSelectOption>
                        ))}
                      </IonSelect>
                    </IonItem>
                  </IonCol>
                </IonRow>
                : null}

                {(user.answerType === 'range') ?
                <IonItem className="ion-range-adjust">
                <IonLabel className = "ion-text-wrap">{user.mobileView} &nbsp; <IonBadge>{this.state.data[index].answer}</IonBadge></IonLabel>
                <IonRange pin={true} step={user.rangeStep} value={parseInt(user.answer)} disabled={user.disableFlag} min={user.answerValue[0]} max={user.answerValue[1]} color = "secondary"
                          onIonChange={e => { this.rangeUpdate(e.detail.value, index) }}>
                {(user.label) ? <IonBadge slot="start">{user.label[0]}</IonBadge> : null}
                {(user.label) ? <IonBadge slot="end">{user.label[1]}</IonBadge> : null}
                </IonRange>
                </IonItem>
                        
                : null}
            </IonCardContent>
          )))}
{(() => {
           
           if(this.state.headerTO.title == 'PROPERTY INFO'){
             return ( 
              <IonRow>
              <IonCol>
                 <IonButton
                 expand="block"
                 class="btncolor"
                 onClick = {this.getEquipmentType}>
                SURVEY QUESTIONS
                 </IonButton>
               </IonCol>
             </IonRow>
            )
         }
       })()} 

{(() => {
           
           if(this.nextPageNumber != 0 && this.state.headerTO.title != 'ADD ONs' && this.state.headerTO.title != 'SECOND SYSTEM' && this.state.headerTO.title != 'SECOND SYSTEM EQUIPMENT INFO' && this.state.headerTO.title != 'PROPERTY INFO' && this.state.headerTO.title != 'EQUIPMENT INFO'  && this.state.headerTO.title != 'DRAINAGE FIELD'){
             return ( 
              <IonRow>
              <IonCol>
                 <IonButton
                 expand="block"
                 class="btncolor"
                 onClick={() => {this.gotoNextPage()}}>
                 SURVEY QUESTIONS
                 </IonButton>
               </IonCol>
             </IonRow>
            )
         }
       })()} 

{(() => {
           
           if(this.state.headerTO.title == 'SURVEY COMPLETED'){
             return ( 
              <IonRow>
              <IonCol>
                 <IonButton
                 expand="block"
                 class="btncolor"
                 onClick={() => this.CompleteSurvey(this.selectedData.id)}>
                SUBMIT
                 </IonButton>
               </IonCol>
             </IonRow>
            )
         }
       })()} 
                 </IonCard>
             </IonContent>
            </IonPage>
            </InsPage>
      );
    };
              
}

const InsPage = styled(IonPage)`
ion-content{
--ion-background-color:#cef2d0;

}
.ion-button{
padding: 8px;
background-color: #019849;
color:#ffffff;
border-radius: 4px;
}
ion-card-content{
font-size: 14px !important;
}
ion-item{
--ion-background-color:#fff;
}
.card_content{
margin-top: 0;
padding: 6px;
bottom: 2px;
color : #006884;
background-color: #ffffff;
font-size: 14px !important;
}
.btn_ins{
padding: 8px;
background-color: #019849;
color: #fff;
}
.ion-item-top-adjust {
position: relative;
top: -10px;

}
.iontitle{
color : #006884;
}
.alert-wrapper ion-overlay-wrapper sc-ion-alert-md{
min-width: -webkit-fit-content;
}
.app-font {
  font-size : 15px;
  }
.text-color {
  color : #019849;
  font-weight : bold;
}

`;

export default (SiteSurveyPage);